import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './WaffleToggleButtonStyles.module.scss';

const block = 'waffle__toggle-button';

class WaffleTextSummary extends React.Component {
  static propTypes = {
    activeText: PropTypes.string,
    inactiveText: PropTypes.string,
    isActive: PropTypes.bool,
    onChangeCallback: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    activeText: 'On',
    inactiveText: 'Off',
    isActive: false,
    onChangeCallback: () => {},
    className: '',
  };

  updateState = () => {
    const { isActive, onChangeCallback } = this.props;
    const currentState = isActive;
    const newState = !currentState;
    onChangeCallback(newState);
  };

  render() {
    const {
      activeText,
      inactiveText,
      className,
      isActive,
    } = this.props;

    const toolkitClasses = 'gray-80 bw0 f3 pt5 pb5 pb7-xl fw6 tl founders-cond ttu';

    let buttonText;
    if (isActive) {
      buttonText = activeText;
    } else {
      buttonText = inactiveText;
    }

    return (
      <button
        type="button"
        onClick={this.updateState}
        className={cx(block, styles.button, toolkitClasses, className, { isActive })}
        data-test="toggle--button"
      >
        <span
          data-test="toggle--button--text"
          className={styles.buttonText}
        >
          {buttonText}
        </span>
        <span className={cx('icon icon-angle-down ml1 f5', styles.arrow)} />
      </button>
    );
  }
}

export default WaffleTextSummary;
